module.exports = __webpack_public_path__ + "img/design.e0b794ee.svg";